$(document).ready(function(){
    $('body').on('click','.quick-view',function(e){
      e.preventDefault();
      console.log('hii');
      if($(this).parents('.predictive-search__list-item').length > 0){
        var openQuickview = $(this).parents('.predictive-search__list-item').find('.quick-add .quick-add__submit');
      }else{
        var openQuickview = $(this).parents('.product-card-wrapper').find('.quick-add .quick-add__submit');
      }
      
      $(openQuickview).trigger("click");
    });
    // $('body').on('click','.product-card-wrapper .button-add-to-cart_main',function(e){
    //   e.preventDefault();
    //   var form = $(this).find('form');
    //   document.querySelector('cart-drawer').setActiveElement(document.activeElement);
    //   // console.log('qqqqq',form.serialize());
    //   $.ajax({
    //     type: 'POST',
    //     url: '/cart/add.js',
    //     data: form.serialize(),
    //     dataType: 'json', 
    //     success: function (data) { 
    //       console.log('datadata',data);
    //       // data['sections']=document.querySelector('cart-drawer').getSectionsToRender().map((section) => section.id);
    //       // document.querySelector('cart-drawer').renderContents(data);
    //     } 
    //   });
    // });

    $(document).on('click', '.menu-icon', function() {
      $('.mobile-header-nav').toggleClass('toggle');
      $('body').toggleClass('opened-drawer');
      $('.overlay-content').toggleClass('overlay');
    });

    $(document).on('click', '.close-button', function() {
      $('.mobile-header-nav').removeClass('toggle');
      $('body').removeClass('opened-drawer');
      $('.overlay-content').removeClass('overlay');
    });

     $(document).mouseup(function (e) {
      var container = $('.mobile-header-nav');
      if (!container.is(e.target) && container.has(e.target).length === 0 && $('.mobile-header-nav').hasClass('toggle')) {
        $('.mobile-header-nav').removeClass('toggle');
        $('.overlay-content').removeClass('overlay');
        $('body').removeClass('opened-drawer');
      }
     });

    $(document).on('click','.sidebar-menu .accordion',function(event) {
      console.log('.accordion');
      event.preventDefault();
      $('.accordion-plus-icon').removeClass('is-open');
      if($(this).next().hasClass('show')) {
        $(this).next().removeClass('show');
        $(this).next().slideUp(350);
        $(this).find('.accordion-plus-icon').removeClass('is-open');
      } else {
        $(this).parent().parent().find('li .dropdown-menus').removeClass('show');
        $(this).parent().parent().find('li .dropdown-menus').slideUp(350);
        $(this).next().toggleClass('show');
        $(this).next().slideToggle(350);
        $(this).find('.accordion-plus-icon').addClass('is-open');
      }
    });

     $(document).on('click','.sidebar-menu .accordion-menu',function(event) {
      event.preventDefault();
      $('.child-accordion-plus-icon').removeClass('is-open');
      if($(this).next().hasClass('show')) {
        $(this).next().removeClass('show');
        $(this).next().slideUp(350);
        $(this).find('.child-accordion-plus-icon').removeClass('is-open');
      } else {
        $(this).parent().parent().find('li .dropdown-grandchild').removeClass('show');
        $(this).parent().parent().find('li .dropdown-grandchild').slideUp(350);
        $(this).next().toggleClass('show');
        $(this).next().slideToggle(350);
        $(this).find('.child-accordion-plus-icon').addClass('is-open');
      }
    });
    // function search_setup(){
    //   if($(window).width() <= 768){
    //     $('.header-drawer .search-modal.modal__content').css('min-height', $(window).height() - 80 + 'px');
    //   }else{
    //     $('.header-drawer .search-modal.modal__content').css('min-height', $('.header-drawer .search-modal.modal__content > .container').innerHeight() + 40 + 'px');
    //   } 
    // }
    // // search_setup();
    // $(window).resize(function(){
    //   search_setup();
    // });
    
});






